import { RESULT_KIND_FOLDER, type ResultKind, TRANSIENT_INPUT_FOLDER } from "../model/constants";

const processingApiBase = process.env.REACT_APP_PROCESSING_API_URL;
const filesApiBase = process.env.REACT_APP_ENERGY_DASHBOARD_API_URL;

export const transientLogFileName = (configId: number) => `${configId}.log`;

export const encodeStoragePath = (path: string) =>
  path
    .split("/")
    .filter(Boolean)
    .map((segment) => encodeURIComponent(segment))
    .join("/");

export const transientRunPrefix = (projectId: string, configId: number) =>
  `raytracing/raytracing/Projects/${projectId}/TransientResponse/${configId}`;

export const transientLogStoragePath = (projectId: string, configId: number) =>
  `${transientRunPrefix(projectId, configId)}/logs/${transientLogFileName(configId)}`;

const resultsDirectoryPath = (projectId: string, configId: number, kind: ResultKind) =>
  `${transientRunPrefix(projectId, configId)}/02_Results/${RESULT_KIND_FOLDER[kind]}`;

export const transientJobUrls = {
  fileDownload: (path: string) => `${filesApiBase}/api/files/download/${encodeStoragePath(path)}`,
  inputDirectory: (projectId: string, configId: number, relativeFolder = "") =>
    `${filesApiBase}/api/list/${encodeStoragePath(
      [transientRunPrefix(projectId, configId), TRANSIENT_INPUT_FOLDER, relativeFolder].filter(Boolean).join("/")
    )}`,
  logDirectory: (projectId: string, configId: number) =>
    `${filesApiBase}/api/list/${encodeStoragePath(`${transientRunPrefix(projectId, configId)}/logs`)}`,
  logs: (jobId: string) => `${processingApiBase}/api/jobs/${encodeURIComponent(jobId)}/logs`,
  resultsDirectory: (projectId: string, configId: number, kind: ResultKind) =>
    `${filesApiBase}/api/list/${encodeStoragePath(resultsDirectoryPath(projectId, configId, kind))}`,
  resultsFolder: (projectId: string, configId: number, kind: ResultKind, folderName: string) =>
    `${filesApiBase}/api/list/${encodeStoragePath(`${resultsDirectoryPath(projectId, configId, kind)}/${folderName}`)}`,
  submit: () => `${processingApiBase}/submit-job`,
};
